<template>
<div v-if="loaded">
  <delete-box
    v-if="profiles.length === 0"
    class="pad-top"
    text="Are you sure you want to delete this action config?"
    loaderText="Deleting Action Config"
    :showLoader="showLoader">
      <a v-on:click="submit" class="add button level-item">
        <i class="far fa-save"></i>
        Delete Action Config
      </a>
  </delete-box>
  <no-delete-box
    v-else
    text="Cannot delete action config because it is associated with the following profiles:">
    <ul>
      <li v-for="profile in profiles" :key="profile.id">
        <router-link :to="{ name: 'profiles.index.detail', params: { id: profile.id }}">
          {{ profile.name }}
        </router-link>
      </li>
    </ul>
  </no-delete-box>
</div>
</template>

<script>
import _ from 'lodash';
import DeleteBox from '@/components/DeleteBox.vue';
import NoDeleteBox from '@/components/NoDeleteBox.vue';

export default {
  name: 'ActionDelete',
  components: { DeleteBox, NoDeleteBox },
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      showLoader: false,
      profiles: [],
    };
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const action = await this.$store.dispatch('primary/deleteActionConfigs', { id: this.action.id });
      this.showLoader = false;
      if (action) {
        this.$router.push({ name: 'actions.index' });
      }
    },
  },
  async beforeMount() {
    const profiles = await this.$store.dispatch('primary/listAllProfiles');
    this.profiles = _.filter(profiles, p => p.actionConfigs.id === this.action.id);
    this.loaded = true;
  },
};
</script>

<style lang="scss" scoped>

.pad-top {
  margin-top: $content-padding;
}
</style>
